@let queryParams = (signupToApplyRouteIncludingInfo() | async) ?? {};
@let logoAlt = 'Homey NYC - Housing Lottery Made Easy logo';
@let headerSrc = '/assets/homey-text.webp';
@let promotion = promotionHeader();

@if(headerStyle() !== 'hidden') {
@if (showPromotionBanner()) {
  <div class="text-white py-3.5 px-3 text-center" [style.background-color]="promotion.color">
    <a class="underline" [routerLink]="promotion.link" (click)="onPromotionHeaderClick()"><span [innerHTML]="promotion.text"></span></a>
  </div>
}
<header
  [ngClass]="{
    'bg-white': headerType === 'default',
    'bg-surface-100': headerType === 'grey',
  }"
  class="relative flex flex-row justify-center items-center drop-shadow">
  <div class="flex flex-row justify-between px-4 thin:px-2 max-w-md md:max-w-lg w-full h-14">
    @switch (headerStyle()) {
      @case ('loading') {
        <a routerLink="/">
          <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14" imageClass="h-full"/>
        </a>
      }
      @case ('landing') {
        <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14" imageClass="h-full"/>
        <div class="flex flex-row items-center">
        @if (!isNative) {
          <homey-signup-button class="self-center" [signupText]="signupToApplyText()" [routeQueryParams]="queryParams"
                               size="small"/>
        } @else {
            <a
              pButton
              aria-label="Common Questions"
              severity="contrast"
              [text]="true"
              [routerLink]="['mobile-faq']"
            >
              <i pButtonIcon
                 style="font-size: 1.2rem"
                 class="pi pi-question-circle"></i>
            </a>
        }
        </div>
      }
      @case ('landing-sub-page') {
        <div class="flex flex-row">
          <homey-back-button/>
          <a routerLink="/">
            <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14" imageClass="h-full"/>
          </a>
        </div>
        <div class="flex flex-row items-center">
          <homey-signup-button class="self-center" [signupText]="signupToApplyText()" [routeQueryParams]="queryParams"
                               size="small"/>
        </div>

      }
      @case ('sub-page') {
        <homey-back-button class="justify-start"/>
        <div class="flex flex-row items-center">
        </div>
      }
      @case ('sub-page-with-logo') {
        <homey-back-button class="flex-1"/>
        <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14 justify-center" imageClass="h-full"/>
        <div class="flex-1">
          <div class="flex flex-row items-center">
          </div>
        </div>
      }
      @case ('root') {
        <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14 self-start" imageClass="h-full"/>
        <div class="flex flex-row items-center">
          <homey-header-buttons/>
        </div>

      }
      @case ('no-back-sub-page') {
        <div class="flex-1"></div>
        <p-image [src]="headerSrc" [alt]="logoAlt" class="block h-14 justify-center" imageClass="h-full"/>
        <div class="flex-1"></div>
      }
    }
  </div>
</header>
@let user = userSignal();
@if (user && user.status !== 'unauthorized' && !hideWarningHeader()) {
  @if (user.simplifiedPaymentInfo.status === 'past-due') {
    <div class="bg-yellow-400 flex flex-row justify-center items-center text-sm thin:text-xs py-2 px-2 font-medium">
      <p class="text-center max-w-md"><i class="pi pi-exclamation-triangle mr-2 align-text-bottom"></i>Oops. Your
        payment failed! <br>
        @if (user.paymentInfo.type === 'revenuecat' && user.paymentInfo.os === 'ios') {
          <a class="underline inline font-semibold" href="https://apps.apple.com/account/subscriptions">Update your payment method</a>
        } @else if (user.paymentInfo.type === 'revenuecat' && user.paymentInfo.os === 'android') {
          <a class="underline inline font-semibold" href="https://play.google.com/store/account/subscriptions?package=io.myhomey.app">Update your payment method</a>
        } @else {
          <a class="underline inline font-semibold" routerLink="/pay">Update your payment method</a>
        }
        to continue using Homey.
      <p>
    </div>
  } @else if (user.simplifiedPaymentInfo.status === 'canceled') {
    @let discount = resubscribeDiscount();
    <div class="bg-yellow-400 flex flex-row justify-center items-center text-sm thin:text-xs py-2 px-2 font-medium">
      <p class="text-center max-w-md"><i class="pi pi-exclamation-triangle mr-2 align-text-bottom"></i>Oops. You
        currently
        don't have an active Homey subscription.
        @if (discount.enabled && discount.couponId && discount.text && !isNative) {
          <a class="underline inline font-semibold" routerLink="/resubscribe">
            <span [innerHTML]="discount.text"></span>
          </a>
        } @else {
          <a class="underline inline font-semibold" routerLink="/resubscribe">Re-subscribe</a>
          to continue using Homey.
        }
      <p>
    </div>
  }
}
}
